import { nonBondedContainer } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getNonBondedContainerList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(nonBondedContainer.nonBondedContainerBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getNonBondedContainerStatusCounts(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${nonBondedContainer.nonBondedContainerBase}status_counts/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  assignNonBondedContainerToTrip(containerId, tripId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${nonBondedContainer.nonBondedContainerBase}${containerId}/assign_to_trip/`, { trip: tripId })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
